module.exports = __webpack_public_path__ + "img/fashion-show.e0f0f836.webp";